export const motionUiTranslations: any = {
  "en-GB": {
    "motion" : {
      "unit" : "Unit {0} '{1}'",
      "hubconnection" :"We have no connection to the plc hub!",
      "viewmode": {
        "symbolic" : "symbolic",
        "address" : "address"
      }
    },
    "motionline": {
      "takeover": {
        "operation": {
          "occupied": "occupied by HmiId: {0}",
          "on": "can be operated in {0} seconds",
          "requested": "requested operation from another HMI.",
          "off": "give away in {0} seconds"
        },
        "permit": "permit",
        "refuse": "refuse"
      },
      "state": {
        "slotNumber": "SlotNo: {0}",
        "dbOffset": "DbOffs: {0}",
        "groupError": "GroupError: {0}",
        "hmiId": "HmiId: {0}",
        "lastChange": "LastChange: {0}",
        "lastInterfaceChange": "LastInterfaceChange: {0}"
      }
    }
  },
  "de-DE": {
    "motion" : {
      "unit" : "Einheit {0} '{1}'",
      "hubconnection" :"Wir haben keine Verbindung zum PlcHub!",
      "viewmode": {
        "symbolic" : "Symbolik",
        "address" : "Adresse"
      }
    },
    "motionline": {
      "takeover": {
        "operation": {
          "occupied": "belegt von HmiId: {0}",
          "on": "Bedienung in {0} Sekunden",
          "requested": "Bedienung von entfernter HMi angefordert.",
          "off": "Abgabe in {0} Sekunden"
        },
        "permit": "zustimmen",
        "refuse": "ablehnen"
      },
      "state": {
        "slotNumber": "Fachnummer: {0}",
        "dbOffset": "DbOffs: {0}",
        "groupError": "GruppenFehler: {0}",
        "hmiId": "HmiId: {0}",
        "lastChange": "Letzte Änderung: {0}",
        "lastInterfaceChange": "Letzte Schnittstellenänderung: {0}"
      }
    }
  }
};